import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

const WidgetBox = ({ children }: { children: ReactNode }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 2.5,
            backgroundColor: '#1a1a2e',
            border: '3px solid #6366f1',
            borderRadius: 0,
        }}
    >
        {children}
    </Box>
);

export default WidgetBox;
